import { faChevronRight, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { HomeNotificationCardProps } from '../../interfaces/props/HomeNotificationCardProps';
import './styles.css';
import { sxHomeShowNotification, sxHoverNotificationCardHome, sxTextNotification } from './sxProps';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

const HomeNotificationCardMobile: React.FC<HomeNotificationCardProps> = ({ icon, text, idComunic, onClick }) => {
    const { calculateFontStyle } = useAccessibility();
    const [isVisible, setIsVisible] = useState(true);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        setIsVisible(false);
    };

    //VERSÃO DO CARD PARA DIMENSÕES DE TELA MENORES

    return (
        isVisible && (
            <Box
                className='notification-card-home'
                sx={sxHoverNotificationCardHome}
                onClick={onClick}
            >
                <Box className='notification-card-home-content'>
                    <div className='home-notification-icon-holder'>
                        <FontAwesomeIcon icon={icon} className='notification-icon-color-home' />
                    </div>
                    <div className='home-notification-details-holder'>
                        <Typography
                            variant="body2"
                            sx={sxTextNotification}
                            style={{
                                ...calculateFontStyle(16)
                            }}
                        >
                            {text}
                        </Typography>
                        <Typography
                            sx={sxHomeShowNotification} style={{
                                paddingLeft: '0px',
                                ...calculateFontStyle(14)
                            }}
                        >
                            Ver notificação
                            <FontAwesomeIcon icon={faChevronRight} size="1x" style={{ marginLeft: '6px' }} />
                        </Typography>
                    </div>
                </Box>

                <div className='home-close-notifications-button'>
                    <IconButton aria-label="Fechar notificação" onClick={handleClick}>
                        <FontAwesomeIcon icon={faTimes} size="1x" color='#383838' />
                    </IconButton>
                </div>
            </Box>
        )
    )
}


export default HomeNotificationCardMobile; 